import { ColDef } from 'ag-grid-community';
import type { TabsProps } from 'antd';
import { Tabs } from 'antd';
import React from 'react';
import '../../../style.scss';


import { ISelectedUserAccount } from './CG_Decentralization';
import { IDataFilterGroupList, IInforAddGroup, IPagination, ISelectedCustomer } from '../../AddGroup/AddNewGroup';
import CG_PrivateNoAutomatic from './CG_PrivateNoAutomatic';
import CG_Decentralization from './CG_Decentralization';



interface props {
    memoizedColumnDefs: ColDef<any, any>[];
    listCustomerNoAutomatic: any[];

    pagination: IPagination;
    dataFilterList: IDataFilterGroupList;
    inforAddGroup: IInforAddGroup
    selectedIdCustomerV9: ISelectedCustomer[]
    listUserSelectedAccount: ISelectedUserAccount[]

    setDataFilterList: (dataFilterList: IDataFilterGroupList) => void;
    // setSelectedIdCustomer: (data: Set<number>) => void;
    setListUserSelectedAccount: React.Dispatch<React.SetStateAction<ISelectedUserAccount[]>>
    onPaginationChange: (page: number, pageSize: number) => void;
}


const CG_SharingNoAutomatic: React.FC<props> = ({
    memoizedColumnDefs, listCustomerNoAutomatic,

    pagination, dataFilterList,
    inforAddGroup, selectedIdCustomerV9,
    listUserSelectedAccount,

    setDataFilterList, setListUserSelectedAccount,
    onPaginationChange,
}) => {

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span className='custom-page-css text-base font-regular'>Danh sách khách hàng</span>,
            children:
                <CG_PrivateNoAutomatic
                    memoizedColumnDefs={memoizedColumnDefs}
                    listCustomerNoAutomatic={listCustomerNoAutomatic}

                    inforAddGroup={inforAddGroup}
                    pagination={pagination}
                    dataFilterList={dataFilterList}
                    selectedIdCustomerV9={selectedIdCustomerV9}

                    setDataFilterList={setDataFilterList}
                    // setSelectedIdCustomer={setSelectedIdCustomer}
                    onPaginationChange={onPaginationChange}
                />,
        },
        {
            key: '2',
            label: <span className='custom-page-css text-base font-regular'>Phân quyền</span>,
            children:
                <CG_Decentralization
                    inforAddGroup={inforAddGroup}
                    listUserSelectedAccount={listUserSelectedAccount}
                    setListUserSelectedAccount={setListUserSelectedAccount}
                />,
        },
    ];

    const onChange = (key: string) => {
        // console.log(key);
    };

    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4 rounded">
            <div className="custom-page-css w-full flex gap-2 items-center">
                <Tabs defaultActiveKey="1" items={items} onChange={onChange} className='w-full' />

            </div>

        </div>
    )
}

export default React.memo(CG_SharingNoAutomatic)
